import axios from 'axios'
import React, { useContext, useEffect } from 'react'
import { Route } from 'react-router-dom'
import { ContextLayout } from '../utility/LayoutContext'
import { host } from '../hooks/serviceGetways';

const FullPageRouter = ({ component: Component, ...rest }) => {
    let { setSettings } = useContext(ContextLayout)
    useEffect(() => {
        axios.get(`${host}/settings`, {}).then(({ data: { result } }) => {
            setSettings(result)
        })
    }, [])
    return (
        <Route {...rest} render={props => (
            <div>
                <Component {...props} />
            </div>
        )} />
    )
}

export default FullPageRouter
